import {cn} from 'utils/cn'

/**
 * Magic UI — Shine Border (tailwind-v3 branch), ported to JS.
 * https://magicui.design/docs/components/shine-border
 *
 * Renders an animated gradient ring just inside the parent's edge. The
 * parent needs `relative` and its own border-radius; the ring inherits
 * the radius and sits on top of whatever border the parent already has.
 * Needs the `shine` keyframes in tailwind.config.js.
 */
export function ShineBorder({
  borderWidth = 1,
  duration = 14,
  shineColor = '#000000',
  className,
  style,
  ...props
}) {
  const colors = Array.isArray(shineColor) ? shineColor.join(',') : shineColor
  return (
    <div
      style={{
        '--border-width': `${borderWidth}px`,
        '--duration': `${duration}s`,
        backgroundImage: `radial-gradient(transparent,transparent, ${colors},transparent,transparent)`,
        backgroundSize: '300% 300%',
        mask: 'linear-gradient(#fff 0 0) content-box, linear-gradient(#fff 0 0)',
        WebkitMask:
          'linear-gradient(#fff 0 0) content-box, linear-gradient(#fff 0 0)',
        WebkitMaskComposite: 'xor',
        maskComposite: 'exclude',
        padding: 'var(--border-width)',
        ...style,
      }}
      className={cn(
        'pointer-events-none absolute inset-0 size-full rounded-[inherit] will-change-[background-position] motion-safe:animate-shine',
        className
      )}
      {...props}
    />
  )
}

export default ShineBorder
